import { Product } from 'shared/types/product/Product';
import ProductDetailsAdapter from 'components/commercetools-ui/organisms/product/product-details/helpers/adapter';
import ProductSchema from 'components/commercetools-ui/organisms/product/product-schema/';
import { DataSource } from 'types/datasource';
import { TasticProps } from 'frontastic/tastics/types';
import WhiteOverlay from 'components/commercetools-ui/atoms/overlay/white-overlay';
import Head from 'components/microhead';
import { searchClient } from 'algolia/searchClient';
import { localeCountryKey } from 'helpers/constants/localeMapping';
import { SITE_URL } from 'helpers/constants/envVariables';
import { getPdpUrl } from 'helpers/utils/pdpUrlHelper';
import JsonBreadcrumbSchema from 'components/commercetools-ui/organisms/json-breadcrumb-schema';

let skusAUFromCache: string[] = [];
let skusNZFromCache: string[] = [];

const ProductDetailsTastic = async ({ data, params, searchParams }: TasticProps<DataSource<{ product: Product }>>) => {
  if (!data?.data?.dataSource?.product) return <WhiteOverlay />;

  if(skusAUFromCache.length==0 || skusNZFromCache.length==0){
    await updateCache();
  }

  const product = data?.data?.dataSource.product;

  const getSkuFromSlug = (slugWithSku: string): string | null =>  {
    const match = slugWithSku.match(/-(\d+)$/); // Matches the last hyphen followed by numbers
    return match ? match[1] : null; // Extracts the SKU or returns null if not found
  }
  const slug = params.slug as string[];  
  const sku = getSkuFromSlug(slug[1]);
  const currentVariantSku = sku;
  let alternateCountryUrlAvailable = false;
  if(sku){
    if(params.locale==localeCountryKey.au){
      if(skusNZFromCache.indexOf(sku)!=-1)
        alternateCountryUrlAvailable = true;
    }
    else {
      if(skusAUFromCache.indexOf(sku)!=-1)
        alternateCountryUrlAvailable = true;
    }
  }
  const variant = product?.variants.find(({ sku }) => sku == currentVariantSku);
  const variantUrl = `${SITE_URL }${params?.locale}${getPdpUrl(product.slug, variant?.sku, variant?.attributes?.colour)}`;

  return (
    <>
      <Head
        title={product.metaTitle || ''}
        metaDescription={product.metaDescription || ''}
        metaKeywords={product.metaKeywords || ''}
        canonical={variantUrl}
        alternateCountryUrlAvailable={alternateCountryUrlAvailable}
        countrylocale={params?.locale}
        ></Head>
        {variant && <ProductSchema product={product} variant={variant} variantUrl={variantUrl} locale={params.locale}></ProductSchema>}        
        <JsonBreadcrumbSchema product={product} variant={variant} currentUrl={variantUrl}/>
      <ProductDetailsAdapter product={product} />
    </>
  );
};

//updateCache every 60 mins
setInterval(() => {
  updateCache();  
}, 60 * 60 * 1000);

const updateCache = async () => {
  [skusAUFromCache, skusNZFromCache] = await Promise.all([
    getSkusForLocale(localeCountryKey.au),
    getSkusForLocale(localeCountryKey.nz)
  ]);  
}

const getSkusForLocale = async (locale:string)=>{
  const algoliaQuery = {
    query: '',
    indexName: locale === localeCountryKey.au 
    ? `${process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX_AU}` 
    : `${process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX_NZ}`,
    params: {
      hitsPerPage: 1000,
      attributesToRetrieve:["slug", "variants.sku"],
    },
  };

  const skus:string[] = [];
  const response: any = await searchClient.search([algoliaQuery]);
  const data = response?.results?.[0]?.hits;
  if (data) {
    data.map((element: any) => {
      element.variants.map((variant: any) => {
        if (variant) skus.push(variant.sku);
      });
    });
  }
  return skus;
};
export default ProductDetailsTastic;
